var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomescreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6358 10.5355L20.9705 12.9986C21.6132 13.4637 21.9956 14.2074 22 15.0007V19.4597C21.9587 20.8895 20.7711 22.0178 19.3411 21.986H12.6653C11.2328 22.0214 10.0413 20.892 10 19.4597V15.0007C10.0044 14.2074 10.3868 13.4637 11.0295 12.9986L14.3642 10.5355C15.3379 9.82151 16.6621 9.82151 17.6358 10.5355ZM13.1579 19.3144H18.8421C19.1037 19.3144 19.3158 19.1023 19.3158 18.8407C19.3158 18.5791 19.1037 18.367 18.8421 18.367H13.1579C12.8963 18.367 12.6842 18.5791 12.6842 18.8407C12.6842 19.1023 12.8963 19.3144 13.1579 19.3144Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomescreen);
export default __webpack_public_path__ + "static/media/homescreen.881a1a19e70426e41ab32a8fd2e26cfb.svg";
export { ForwardRef as ReactComponent };